'use strict';


/*@ngInject*/
export function FilesService($resource) {
  return $resource('/api/files/:id', {
    id: '@_id'
  }, {
    read: {

      method: 'GET',
      params: {
        id: '@_id'
      }
    },
    remove: {
      method: 'DELETE',
      params: {
        id: '@_id'
      },
    }
  });
}

export default angular.module('fplTruescapeComApp.Files', [])
  .service('Files', FilesService)
  .name;



// WEBPACK FOOTER //
// ./client/components/Files/Files.service.js